@if (navStateConfig$ | async; as config) {
  <mat-sidenav-container
    autosize="false"
    [hasBackdrop]="config.sideNav.matSideNavMode === 'over'"
    [ngClass]="[
      'global-side-nav__mode-' + config.sideNav.matSideNavMode,
      'global-side-nav__state-' + config.sideNav.sideNavState,
      'breakpoint__mode-' + config.breakpointMode,
    ]"
  >
    <mat-sidenav
      id="global-side-nav-content-slot"
      role="navigation"
      [mode]="config.sideNav.matSideNavMode"
      [opened]="config.sideNav.matIsSideNavOpened"
      fixedTopGap="0"
      [fixedInViewport]="config.sideNav.matSideNavMode === 'over'"
    >
      <global-side-nav-content></global-side-nav-content>
    </mat-sidenav>

    <mat-sidenav-content #mainSlot id="main-slot" role="main">
      <ng-content select="[main]"></ng-content>
    </mat-sidenav-content>
  </mat-sidenav-container>
}
